import {
  EpisodeReadPositionRequestDto,
  EpisodeReadPositionResponseDto,
} from '@diritto/common/recentlyRead/dtos/episdoe-read-position.dto';
import { EpisodeReadRecordsResponseDto } from '@diritto/common/recentlyRead/dtos/episdoe-read-record.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class EpisodeReadRecordApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getLatestReadPerEpisodesByContentId(contentId: number) {
    const res = await this.http.get<EpisodeReadRecordsResponseDto>(
      `${this.url}/episode-reads/contents/${contentId}/latest-per-episode`,
    );
    return res.data;
  }

  async getPosition(contentId: number, episodeId: number) {
    const res = await this.http.get<EpisodeReadPositionResponseDto>(
      `${this.url}/episode-reads/contents/${contentId}/episodes/${episodeId}/position`,
    );
    return res.data;
  }

  async recordPosition(contentId: number, episodeId: number, position: number) {
    const res = await this.http.post<EpisodeReadPositionRequestDto, EpisodeReadPositionResponseDto>(
      `${this.url}/episode-reads/contents/${contentId}/episodes/${episodeId}/position`,
      {
        position,
      },
    );
    return res.data;
  }
}
